// Shared option lists + sample prompts for the Virtual Receptionist config form.
// Used by both the settings panel (VapiIntegration) and the onboarding wizard
// (ReceptionistConfigStep) so Voice/Model are picked from a list (not free text)
// and users can pull in a ready-made answering prompt.

// Voice choices (value = the assistant voiceId sent on provision).
export const VOICE_OPTIONS = [
  { value: "Elliot", label: "Elliot — warm, male" },
  { value: "Cole", label: "Cole — professional, male" },
  { value: "Harry", label: "Harry — friendly, male" },
  { value: "Rohan", label: "Rohan — calm, male" },
  { value: "Spencer", label: "Spencer — upbeat, male" },
  { value: "Kylie", label: "Kylie — friendly, female" },
  { value: "Paige", label: "Paige — professional, female" },
  { value: "Hana", label: "Hana — warm, female" },
  { value: "Neha", label: "Neha — calm, female" },
  { value: "Savannah", label: "Savannah — upbeat, female" },
];

export const DEFAULT_VOICE = "Elliot";

// Model choices (value = the assistant model sent on provision).
export const MODEL_OPTIONS = [
  { value: "gpt-4o", label: "Standard (recommended)" },
  { value: "gpt-4o-mini", label: "Fast & economical" },
  { value: "gpt-4.1", label: "Advanced" },
  { value: "gpt-4.1-mini", label: "Advanced (economical)" },
];

export const DEFAULT_MODEL = "gpt-4o";

// Ready-made answering prompts the user can pull in and then tweak. Each sample
// carries a matching greeting so both fields can be populated at once.
export const SAMPLE_PROMPTS = [
  {
    label: "General receptionist",
    greeting: "Hello, thanks for calling — how can I help you today?",
    prompt:
      "You are a friendly, professional virtual receptionist answering inbound phone calls for the business. Greet the caller warmly, find out how you can help, and keep replies concise and natural. You can check appointment availability, book appointments, and take a message for the team using your tools. Always confirm names, phone numbers and addresses back to the caller. If you cannot help, offer to take a message. Never invent information you do not have.",
  },
  {
    label: "Trades / field service (booking-focused)",
    greeting:
      "Hi, thanks for calling. Are you looking to book an appointment or is it about an existing job?",
    prompt:
      "You are the virtual receptionist for a trades/field-service business (e.g. plumbing, heating, electrical). Your main goal is to book appointments. Ask what the job is, the property address and postcode, and how urgent it is. Use your tools to check availability and offer the earliest suitable slots, then book the appointment once the caller confirms. Capture the caller's name, phone number and address and read them back to confirm. If you cannot book, take a detailed message for the team. Be practical, reassuring and efficient.",
  },
  {
    label: "Restaurant / bookings",
    greeting:
      "Hello, thanks for calling. Would you like to make a booking or check an existing one?",
    prompt:
      "You are the virtual receptionist for a restaurant. Help callers make a booking: ask for the date and time, party size, and any dietary requirements or special occasions. Use your tools to check availability and confirm the booking. Capture the caller's name and phone number and read them back to confirm. If the requested time is unavailable, offer the nearest alternatives. If you cannot help, take a message. Be warm, welcoming and concise.",
  },
  {
    label: "Out of hours / message only",
    greeting:
      "Hello, you've reached us outside our normal hours. I can take a message and we'll get back to you.",
    prompt:
      "You are the out-of-hours virtual receptionist. The team is not available to take the call, so your job is to take a clear message. Politely explain the team is currently unavailable, then capture the caller's name, phone number, and the reason for their call. Confirm the details back to them and reassure them that someone will get back to them as soon as possible. Be calm, friendly and brief.",
  },
];
